import type { ReactNode } from 'react'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  children: ReactNode
}

function ChatListSectionLabel({ children }: Props) {
  return (
    <BodyText variant="small" weight="bold" colour="neutral-three" as="h2">
      {children}
    </BodyText>
  )
}

export default ChatListSectionLabel
